import { render, staticRenderFns } from "./ExtraFeeHistoryModal.vue?vue&type=template&id=33548250&scoped=true&"
import script from "./ExtraFeeHistoryModal.vue?vue&type=script&lang=js&"
export * from "./ExtraFeeHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./ExtraFeeHistoryModal.vue?vue&type=style&index=0&id=33548250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33548250",
  null
  
)

export default component.exports